import GeoJsonLayer from 'src/services/geoJson/GeoJsonLayer';

export default class TrafficLayer extends GeoJsonLayer {
  /** @var {String} id */
  static id = 'traffic';
}
